import React from "react";
import { Button } from "react-bootstrap";
import { CancelIcon, PayIcon } from "../gui_components/Icons.js";

export class ARModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowPostButton: this.props.isShowPostButton,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowReverseButton: this.props.isShowReverseButton,
    };
  }

  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  postAccountReceivable = (e) => {
    if (e.detail === 1) this.props.postAccountReceivable();
  };

  cancelAccountReceivable = (e) => {
    if (e.detail === 1) this.props.cancelAccountReceivable();
  };

  reverseAccountReceivable = (e) => {
    if (e.detail === 1) this.props.reverseAccountReceivable();
  };
  paymentHistoryReport = (e) => {
    if (e.detail === 1) this.props.paymentHistoryReport();
  };
  generateMail = (e) => {
    if (e.detail === 1) this.props.generateMail();
  };

  render() {
    return (
      <>
        {this.props.isShowPostButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.postAccountReceivable(e)}
          >
            <PayIcon />
            Post
          </Button>
        )}

        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelAccountReceivable(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {this.props.isShowReverseButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.reverseAccountReceivable(e)}
          >
            <CancelIcon />
            Reverse
          </Button>
        )}
        {this.props.isShowPaymentHistoryButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.paymentHistoryReport(e)}
          >
            PaymentHistory
          </Button>
        )}
        {this.props.isShowMailButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateMail(e)}
          >
            Mail
          </Button>
        )}
      </>
    );
  }
}
